import { getEnv } from '../../config';

const { publicPath } = getEnv();

// APP ROUTES
export const HOME: string = `${publicPath}`;

// PUBLIC ROUTES
export const IMAGES_PATH: string = `${publicPath}/assets/images`;
